import { Badge } from '@/components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { StandardContractView } from '../contract-types';
import { StandardContractRowActions } from './standard-contract-row-actions';

interface StandardContractTableProps {
  contracts: StandardContractView[];
  onConfigure?: (contract: StandardContractView) => void;
  onEdit?: (contract: StandardContractView) => void;
  onShowHistory?: (contract: StandardContractView) => void;
  onPublishVersion?: (contract: StandardContractView) => void;
}

export function StandardContractTable({
  contracts,
  onConfigure,
  onEdit,
  onShowHistory,
  onPublishVersion,
}: StandardContractTableProps) {
  return (
    <div className="overflow-x-auto rounded-md border bg-white">
      <Table className="min-w-[680px]">
        <TableHeader>
          <TableRow>
            <TableHead>Tipo de contrato</TableHead>
            <TableHead className="w-[140px]">Versão</TableHead>
            <TableHead className="w-[140px]">Status</TableHead>
            <TableHead className="w-[220px] text-right">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {contracts.map((contract) => (
            <TableRow key={contract.id}>
              <TableCell>
                <div className="flex flex-col">
                  <span className="font-medium text-gray-900">{contract.label}</span>
                  <span className="text-xs text-muted-foreground">{contract.description}</span>
                </div>
              </TableCell>
              <TableCell className="font-medium tabular-nums">{contract.version ?? '-'}</TableCell>
              <TableCell>
                {contract.active === null ? (
                  '-'
                ) : (
                  <Badge variant="secondary-subtle">{contract.active ? 'Ativo' : 'Inativo'}</Badge>
                )}
              </TableCell>
              <TableCell className="text-right">
                <StandardContractRowActions
                  contract={contract}
                  onConfigure={onConfigure}
                  onEdit={onEdit}
                  onShowHistory={onShowHistory}
                  onPublishVersion={onPublishVersion}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
